import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../core/interfaces'
import { CityFilter } from '../../entities'
import { getCitites } from '../general'

export default function useCities(query: PaginatedRequest<CityFilter>) {
  const { data, error, isLoading } = useQuery(
    ['cities', query],
    () => getCitites(query),
    {
      enabled: !!query?.filters?.state
    }
  )
  return { data, error, isLoading }
}
